import React from 'react'
import * as Icons from 'lucide-react'
import { LucideProps } from 'lucide-react'

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: keyof typeof Icons;
}

const Icon = ({name, size = 20, ...props}: IconProps) => {
  const IconComponent = Icons[name];
  if (!IconComponent) {
      return <Icons.HelpCircle size={size} {...props} />;
  }
  const ValidIconComponent = IconComponent as React.ElementType;
  return <ValidIconComponent size={size} {...props} />;
}

export default Icon
